<template>
  <div class="flex flex-wrap">
    <DatePicker
      class-name="first"
      :disabled="mutableOptions.from.disabled || disabled"
      :fixed_value="fixed_value"
      :max-date="dateRange[1] || (mutableOptions.from.max > mutableOptions.from.min ? mutableOptions.from.max : null )"
      :min-date="mutableOptions.from.min"
      :period.sync="dateRange"
      range
      :range_part="0"
      @chooseDate="chooseDate"/>
    <DatePicker
      class-name="second"
      :disabled="mutableOptions.to.disabled || disabled"
      :fixed_value="fixed_value"
      :max-date="mutableOptions.to.max"
      :min-date="dateRange[0] || mutableOptions.to.min"
      :period.sync="dateRange"
      range
      :range_part="1"
      @chooseDate="chooseDate"/>
  </div>
</template>
<script>
import DatePicker from 'components/common/elements/DatePicker.vue'

import { datePickerMixin , componentOptions} from 'mixins'

export default {
  name: 'datePickerPair',
  mixins: [ datePickerMixin , componentOptions],
  data() {
    return {
      month: '',
      mutableOptions: {
        from: {
          default: null,
          disabled: false,
          min: null,
        },
        to: {
          default: null,
          disabled: false,
          min: null,
        },
      },
    }
  },
  props: {
    disabled: [ Boolean, String ],
    period: [Array, String],
    range: Boolean,
    fixed_value: String,
  },
  computed: {
    dateRange: {
      get() {
        return this.period
      },
      set(newValue) {
        this.$emit('update:period', newValue )
      }
    },
  },
  methods: {
    chooseDate(date) {
      this.$emit('chooseDate', date)
    },
  },
  components: {
    DatePicker
  }
}
</script>
